export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects'
    },
    home: {
      greeting: "Hello, I'm Thiago",
      subtitle: "Data Science Lead & DevOps at Educat | Machine Learning | Python | SQL | AWS | Power BI",
      cta: {
        projects: "View Projects",
        about: "About Me"
      }
    },
    about: {
      title: 'About Me',
      profile: {
        title: 'Professional Profile',
        description: 'Data scientist with over two years of experience in data analysis. I have helped develop technological solutions for major names in the education sector, such as Fundação Getúlio Vargas (FGV), SESI, Secretaria de Estado e Educação do Mato Grosso, Ciências Médicas, and dozens of medical societies in Brazil. Notable solutions include adaptive teaching systems, offline electronic test applications, application monitoring systems, and AI Assistant professor.'
      },
      skills: {
        title: 'Technical Skills',
        programming: {
          title: 'Data Processing',
          items: ['Python', 'SQL', 'SQL Server', 'AWS RDS', 'PostgreSQL']
        },
        tools: {
          title: 'Technologies',
          items: ['Machine Learning', 'Django', 'Kubernetes', 'Docker', 'Git']
        },
        visualization: {
          title: 'Data Visualization',
          items: ['Power BI', 'Excel', 'Data Modeling']
        },
        cloud: {
          title: 'Cloud & Infrastructure',
          items: ['AWS (S3, RDS, EC2)', 'Kubernetes', 'Container Orchestration']
        }
      },
      experience: {
        title: 'Professional Experience',
        jobs: [
          {
            title: 'Data Science Lead & DevOps',
            company: 'EDUCAT Tecnologia',
            period: 'Feb/2023 - Present',
            responsibilities: [
              'Development and maintenance of interactive dashboards using Power BI and SQL Server',
              'Optimization and execution of complex SQL queries for data insights',
              'Data processing, analysis, and modeling using Python',
              'Machine Learning application to predict trends and patterns',
              'Automation of processes to enhance operational efficiency',
              'Advanced data analysis with MS Excel',
              'Development and management of SQL Server procedures',
              'Monitoring and administration of databases in AWS RDS',
              'Container orchestration and management with Kubernetes',
              'Python backend development with DJANGO'
            ]
          },
          {
            title: 'Data Analyst',
            company: 'Freelancer',
            period: 'Dec/2022 - Dec/2023',
            responsibilities: [
              'Created and monitored key performance indicators (KPIs)',
              'Designed and maintained dashboards using Power BI',
              'Processed and cleaned large datasets',
              'Handled large-scale data manipulation using SQL',
              'Conducted data quality and integrity testing using Python and SQL'
            ]
          },
          {
            title: 'Database Technical Consultant',
            company: 'Devs-X',
            period: 'Dec/2024 - Apr/2024',
            responsibilities: [
              'Led database modeling and optimization for a PostgreSQL-based payment gateway, handling over 100,000 BRL in financial transactions',
              'Optimized AWS RDS costs, reducing expenses by approximately one-third',
              'Managed PostgreSQL database maintenance'
            ]
          }
        ],
        education: {
          title: 'Education',
          items: [
            {
              degree: 'Technology in Data Science',
              institution: 'Centro Universitário Internacional - UNINTER',
              period: '2022 - 2025',
              location: 'Belo Horizonte - MG - Brazil (Online)'
            },
            {
              degree: 'IBM Data Science Professional Certificate',
              institution: 'Coursera - IBM',
              period: 'Feb/2025 - Mar/2025',
              location: 'Belo Horizonte - MG - Brazil (Online)'
            },
            {
              degree: 'SQL Basics for Data Science',
              institution: 'Coursera - University of California, Davis',
              period: 'Feb/2025 - Mar/2025',
              location: 'Belo Horizonte - MG - Brazil (Online)'
            }
          ]
        }
      }
    },
    projects: {
      title: 'Projects',
      cards: [
        {
          title: 'Twitter Sentiment Analysis',
          description: 'NLP project for sentiment analysis of tweets on specific topics.',
          technologies: ['Python', 'NLTK', 'Scikit-learn', 'Pandas'],
          links: {
            github: 'View on GitHub',
            demo: 'Live Demo'
          }
        },
        {
          title: 'Public Stocks Portfolio',
          description: 'Interactive dashboard for public stocks portfolio analysis using Yahoo Finance API and connecting with my personal stocks portfolio. This project also includes a feature with a XGBoost model to predict the future price of the stocks and sugest if it is a good time to buy or sell.',
          technologies: ['Python', 'Yahoo Finance API', 'Streamlit', 'Plotly', 'Pandas', 'XGBoost'],
          links: {
            github: 'View on GitHub',
            demo: 'Live Demo'
          }
        },
        {
          title: 'Data Analysis Dashboard',
          description: 'Interactive dashboard for business metrics visualization.',
          technologies: ['Python', 'Dash', 'Plotly', 'Pandas'],
          links: {
            github: 'View on GitHub',
            demo: 'Live Demo'
          }
        }
      ]
    },
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      viewMore: 'View More',
      close: 'Close'
    },
    chat: {
      title: "Ask me anything about my experience",
      description: "Feel free to ask questions about my skills, experience, projects, or anything else you'd like to know!",
      placeholder: "Type your question here...",
      send: "Send",
      error: "Sorry, I couldn't process your request at the moment. Please try again later.",
      underConstruction: "🚧 The chat assistant is under construction. Coming soon! 🔨",
      staticResponse: "🚧 Hi! The virtual assistant is under construction. Soon I'll be available to answer your questions about my professional experience. Meanwhile, you can check my resume in the section above! 🔨"
    },
    privacy: {
      title: 'Privacy Policy',
      company: {
        title: 'Company Information',
        name: 'Company Name',
        cnpj: 'CNPJ',
        address: 'Address',
        email: 'Email',
        phone: 'Phone'
      },
      collection: {
        title: 'Data Collection',
        description: 'We collect the following information when you visit our website:',
        items: [
          'Navigation data (IP address, browser, operating system)',
          'Contact information when provided voluntarily',
          'Cookies and similar technologies for website improvement',
          'Professional interaction information (messages, inquiries)'
        ]
      },
      usage: {
        title: 'Data Usage',
        description: 'Collected data is used for:',
        items: [
          'Improving user experience on the website',
          'Responding to inquiries and contact requests',
          'Analyzing website traffic and performance',
          'Legal compliance and fraud prevention'
        ]
      },
      sharing: {
        title: 'Data Sharing',
        description: 'We do not sell, rent, or share your personal information with third parties, except when required by law or with your explicit consent.'
      },
      cookies: {
        title: 'Cookies',
        description: 'We use cookies to improve your browsing experience. You can configure your browser to reject cookies, but this may affect some website functionalities.'
      },
      security: {
        title: 'Security',
        description: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.'
      },
      rights: {
        title: 'Your Rights',
        description: 'In accordance with LGPD (General Data Protection Law), you have the right to:',
        items: [
          'Access your personal data',
          'Correct incomplete, inaccurate, or outdated data',
          'Request deletion of your data',
          'Request portability of your data',
          'Revoke consent for data processing'
        ]
      },
      lgpd: {
        title: 'LGPD Compliance',
        description: 'This website complies with the General Data Protection Law (LGPD - Law 13.709/2018) and respects all user rights regarding the processing of personal data.'
      },
      changes: {
        title: 'Policy Changes',
        description: 'We reserve the right to update this privacy policy at any time. Changes will be posted on this page with the update date.'
      },
      contact: {
        title: 'Contact',
        description: 'For questions about this privacy policy or to exercise your rights, please contact us through the information provided above.'
      },
      lastUpdate: 'Last updated'
    },
    terms: {
      title: 'Terms and Conditions',
      company: {
        title: 'Company Information',
        name: 'Company Name',
        cnpj: 'CNPJ',
        address: 'Address',
        email: 'Email'
      },
      acceptance: {
        title: 'Acceptance of Terms',
        description: 'By accessing and using this website, you accept and agree to be bound by the terms and conditions contained in this Terms of Use and all applicable laws and regulations.'
      },
      usage: {
        title: 'Website Use',
        description: 'This website is intended to showcase professional portfolio, projects, and services. You agree to:',
        items: [
          'Not use the website for illegal or unauthorized purposes',
          'Not attempt to gain unauthorized access to any part of the website',
          'Not interfere with the proper functioning of the website',
          'Not copy, modify, or distribute content without authorization'
        ]
      },
      intellectual: {
        title: 'Intellectual Property',
        description: 'All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of the owner and is protected by copyright laws.'
      },
      services: {
        title: 'Services Offered',
        description: 'This website provides information about:',
        items: [
          'Data Science and Analytics services',
          'Software Development and DevOps consulting',
          'Machine Learning and AI solutions',
          'Professional portfolio and project showcase'
        ]
      },
      liability: {
        title: 'Limitation of Liability',
        description: 'The website and its content are provided "as is" without any warranties. We are not liable for any damages arising from the use or inability to use this website.'
      },
      links: {
        title: 'External Links',
        description: 'This website may contain links to external websites. We are not responsible for the content or privacy practices of these external sites.'
      },
      modifications: {
        title: 'Terms Modifications',
        description: 'We reserve the right to modify these terms at any time. Continued use of the website after changes constitutes acceptance of the new terms.'
      },
      law: {
        title: 'Applicable Law',
        description: 'These terms are governed by the laws of the Federative Republic of Brazil. Any disputes will be resolved in the courts of Brazil.'
      },
      contact: {
        title: 'Contact',
        description: 'For questions about these terms and conditions, please contact us through the information provided above.'
      },
      lastUpdate: 'Last updated'
    },
    contact: {
      title: 'Contact',
      company: {
        title: 'Company Information',
        name: 'Company Name',
        cnpj: 'CNPJ',
        address: 'Address',
        email: 'Email',
        phone: 'Phone'
      },
      social: {
        title: 'Social Networks'
      },
      hours: {
        title: 'Business Hours',
        description: 'Available for inquiries Monday through Friday, 9:00 AM to 6:00 PM (Brasília Time - GMT-3)'
      }
    },
    footer: {
      company: {
        title: 'Company',
        name: 'Company Name',
        cnpj: 'CNPJ',
        address: 'Address'
      },
      legal: {
        title: 'Legal',
        privacy: 'Privacy Policy',
        terms: 'Terms and Conditions',
        contact: 'Contact'
      },
      contact: {
        title: 'Contact',
        email: 'Email',
        phone: 'Phone'
      },
      rights: 'All rights reserved'
    }
  },
  pt: {
    nav: {
      home: 'Home',
      about: 'Sobre Mim',
      projects: 'Projetos'
    },
    home: {
      greeting: "Olá, eu sou o Thiago",
      subtitle: "Data Science Lead & DevOps na Educat | Machine Learning | Python | SQL | AWS | Power BI",
      cta: {
        projects: "Ver Projetos",
        about: "Sobre Mim"
      }
    },
    about: {
      title: 'Sobre Mim',
      profile: {
        title: 'Perfil Profissional',
        description: 'Cientista de dados com mais de dois anos de experiência em análise de dados. Ajudei a desenvolver soluções tecnológicas para grandes nomes do setor educacional, como Fundação Getúlio Vargas (FGV), SESI, Secretaria de Estado e Educação do Mato Grosso, Ciências Médicas e dezenas de sociedades médicas no Brasil. Soluções notáveis incluem sistemas de ensino adaptativo, aplicação de testes eletrônicos offline, sistema de monitoramento de aplicações e professor assistente com IA.'
      },
      skills: {
        title: 'Habilidades Técnicas',
        programming: {
          title: 'Processamento de Dados',
          items: ['Python', 'SQL', 'SQL Server', 'AWS RDS', 'PostgreSQL']
        },
        tools: {
          title: 'Tecnologias',
          items: ['Machine Learning', 'Django', 'Kubernetes', 'Docker', 'Git']
        },
        visualization: {
          title: 'Visualização de Dados',
          items: ['Power BI', 'Excel', 'Modelagem de Dados']
        },
        cloud: {
          title: 'Cloud & Infraestrutura',
          items: ['AWS (S3, RDS, EC2)', 'Kubernetes', 'Orquestração de Containers']
        }
      },
      experience: {
        title: 'Experiência Profissional',
        jobs: [
          {
            title: 'Data Science Lead & DevOps',
            company: 'EDUCAT Tecnologia',
            period: 'Fev/2023 - Presente',
            responsibilities: [
              'Desenvolvimento e manutenção de dashboards interativos usando Power BI e SQL Server',
              'Otimização e execução de queries SQL complexas para insights de dados',
              'Processamento, análise e modelagem de dados usando Python',
              'Aplicação de Machine Learning para prever tendências e padrões',
              'Automação de processos para melhorar a eficiência operacional',
              'Análise avançada de dados com MS Excel',
              'Desenvolvimento e gerenciamento de procedimentos SQL Server',
              'Monitoramento e administração de bancos de dados em AWS RDS',
              'Orquestração e gerenciamento de containers com Kubernetes',
              'Desenvolvimento backend em Python com DJANGO'
            ]
          },
          {
            title: 'Analista de Dados',
            company: 'Freelancer',
            period: 'Dez/2022 - Dez/2023',
            responsibilities: [
              'Criou e monitorou indicadores-chave de desempenho (KPIs)',
              'Projetou e manteve dashboards usando Power BI',
              'Processou e limpou grandes conjuntos de dados',
              'Gerenciou manipulação de dados em larga escala usando SQL',
              'Realizou testes de qualidade e integridade de dados usando Python e SQL'
            ]
          },
          {
            title: 'Consultor Técnico de Banco de Dados',
            company: 'Devs-X',
            period: 'Dez/2024 - Abr/2024',
            responsibilities: [
              'Liderou a modelagem e otimização de banco de dados para um gateway de pagamento baseado em PostgreSQL, processando mais de 100.000 BRL em transações financeiras',
              'Otimizou custos do AWS RDS, reduzindo despesas em aproximadamente um terço',
              'Gerenciou manutenção de banco de dados PostgreSQL'
            ]
          }
        ],
        education: {
          title: 'Educação',
          items: [
            {
              degree: 'Tecnologia em Ciência de Dados',
              institution: 'Centro Universitário Internacional - UNINTER',
              period: '2022 - 2025',
              location: 'Belo Horizonte - MG - Brasil (Online)'
            },
            {
              degree: 'Certificado Profissional em Ciência de Dados IBM',
              institution: 'Coursera - IBM',
              period: 'Fev/2025 - Mar/2025',
              location: 'Belo Horizonte - MG - Brasil (Online)'
            },
            {
              degree: 'Fundamentos de SQL para Ciência de Dados',
              institution: 'Coursera - University of California, Davis',
              period: 'Fev/2025 - Mar/2025',
              location: 'Belo Horizonte - MG - Brasil (Online)'
            }
          ]
        }
      }
    },
    projects: {
      title: 'Projetos',
      cards: [
        {
          title: 'Análise de Sentimento do Twitter',
          description: 'Projeto de NLP para análise de sentimento de tweets sobre tópicos específicos.',
          technologies: ['Python', 'NLTK', 'Scikit-learn', 'Pandas'],
          links: {
            github: 'Ver no GitHub',
            demo: 'Demonstração'
          }
        },
        {
          title: 'Portfólio de Ações Públicas',
          description: 'Dashboard interativo para análise de portfólio de ações públicas usando Yahoo Finance API e conectando com meu portfólio de ações pessoais. Este projeto também inclui um recurso com um modelo XGBoost para prever o preço futuro das ações e sugerir se é um bom momento para comprar ou vender.',
          technologies: ['Python', 'Yahoo Finance API', 'Streamlit', 'Plotly', 'Pandas', 'XGBoost'],
          links: {
            github: 'Ver no GitHub',
            demo: 'Demonstração'
          }
        },
        {
          title: 'Dashboard de Análise de Dados',
          description: 'Dashboard interativo para visualização de métricas de negócio.',
          technologies: ['Python', 'Dash', 'Plotly', 'Pandas'],
          links: {
            github: 'Ver no GitHub',
            demo: 'Demonstração'
          }
        }
      ]
    },
    common: {
      loading: 'Carregando...',
      error: 'Ocorreu um erro',
      viewMore: 'Ver Mais',
      close: 'Fechar'
    },
    chat: {
      title: "Pergunte-me sobre minha experiência",
      description: "Sinta-se à vontade para fazer perguntas sobre minhas habilidades, experiência, projetos ou qualquer outra coisa que queira saber!",
      placeholder: "Digite sua pergunta aqui...",
      send: "Enviar",
      error: "Desculpe, não consegui processar sua solicitação no momento. Por favor, tente novamente mais tarde.",
      underConstruction: "🚧 O assistente de chat está em construção. Em breve estará disponível! 🔨",
      staticResponse: "🚧 Olá! O assistente virtual está em construção. Em breve estarei disponível para responder suas perguntas sobre minha experiência profissional. Por enquanto, você pode conferir meu currículo na seção acima! 🔨"
    },
    privacy: {
      title: 'Política de Privacidade',
      company: {
        title: 'Informações da Empresa',
        name: 'Nome da Empresa',
        cnpj: 'CNPJ',
        address: 'Endereço',
        email: 'E-mail',
        phone: 'Telefone'
      },
      collection: {
        title: 'Coleta de Dados',
        description: 'Coletamos as seguintes informações quando você visita nosso site:',
        items: [
          'Dados de navegação (endereço IP, navegador, sistema operacional)',
          'Informações de contato quando fornecidas voluntariamente',
          'Cookies e tecnologias semelhantes para melhorar o site',
          'Informações de interação profissional (mensagens, consultas)'
        ]
      },
      usage: {
        title: 'Uso dos Dados',
        description: 'Os dados coletados são utilizados para:',
        items: [
          'Melhorar a experiência do usuário no site',
          'Responder a consultas e solicitações de contato',
          'Analisar o tráfego e desempenho do site',
          'Cumprimento de obrigações legais e prevenção de fraudes'
        ]
      },
      sharing: {
        title: 'Compartilhamento de Dados',
        description: 'Não vendemos, alugamos ou compartilhamos suas informações pessoais com terceiros, exceto quando exigido por lei ou com seu consentimento explícito.'
      },
      cookies: {
        title: 'Cookies',
        description: 'Utilizamos cookies para melhorar sua experiência de navegação. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar algumas funcionalidades do site.'
      },
      security: {
        title: 'Segurança',
        description: 'Implementamos medidas de segurança apropriadas para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.'
      },
      rights: {
        title: 'Seus Direitos',
        description: 'De acordo com a LGPD (Lei Geral de Proteção de Dados), você tem direito a:',
        items: [
          'Acessar seus dados pessoais',
          'Corrigir dados incompletos, inexatos ou desatualizados',
          'Solicitar a exclusão de seus dados',
          'Solicitar a portabilidade de seus dados',
          'Revogar o consentimento para tratamento de dados'
        ]
      },
      lgpd: {
        title: 'Conformidade com a LGPD',
        description: 'Este site está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018) e respeita todos os direitos dos usuários em relação ao tratamento de dados pessoais.'
      },
      changes: {
        title: 'Alterações na Política',
        description: 'Reservamo-nos o direito de atualizar esta política de privacidade a qualquer momento. As alterações serão publicadas nesta página com a data de atualização.'
      },
      contact: {
        title: 'Contato',
        description: 'Para dúvidas sobre esta política de privacidade ou para exercer seus direitos, entre em contato através das informações fornecidas acima.'
      },
      lastUpdate: 'Última atualização'
    },
    terms: {
      title: 'Termos e Condições',
      company: {
        title: 'Informações da Empresa',
        name: 'Nome da Empresa',
        cnpj: 'CNPJ',
        address: 'Endereço',
        email: 'E-mail'
      },
      acceptance: {
        title: 'Aceitação dos Termos',
        description: 'Ao acessar e usar este site, você aceita e concorda em estar vinculado aos termos e condições contidos nestes Termos de Uso e todas as leis e regulamentos aplicáveis.'
      },
      usage: {
        title: 'Uso do Site',
        description: 'Este site destina-se a apresentar portfólio profissional, projetos e serviços. Você concorda em:',
        items: [
          'Não usar o site para fins ilegais ou não autorizados',
          'Não tentar obter acesso não autorizado a qualquer parte do site',
          'Não interferir no funcionamento adequado do site',
          'Não copiar, modificar ou distribuir conteúdo sem autorização'
        ]
      },
      intellectual: {
        title: 'Propriedade Intelectual',
        description: 'Todo o conteúdo deste site, incluindo mas não limitado a textos, gráficos, logos, imagens e software, é propriedade do titular e está protegido pelas leis de direitos autorais.'
      },
      services: {
        title: 'Serviços Oferecidos',
        description: 'Este site fornece informações sobre:',
        items: [
          'Serviços de Ciência de Dados e Analytics',
          'Consultoria em Desenvolvimento de Software e DevOps',
          'Soluções de Machine Learning e IA',
          'Portfólio profissional e demonstração de projetos'
        ]
      },
      liability: {
        title: 'Limitação de Responsabilidade',
        description: 'O site e seu conteúdo são fornecidos "como estão" sem qualquer garantia. Não nos responsabilizamos por quaisquer danos decorrentes do uso ou incapacidade de usar este site.'
      },
      links: {
        title: 'Links Externos',
        description: 'Este site pode conter links para sites externos. Não somos responsáveis pelo conteúdo ou práticas de privacidade desses sites externos.'
      },
      modifications: {
        title: 'Modificações dos Termos',
        description: 'Reservamo-nos o direito de modificar estes termos a qualquer momento. O uso contínuo do site após as alterações constitui aceitação dos novos termos.'
      },
      law: {
        title: 'Lei Aplicável',
        description: 'Estes termos são regidos pelas leis da República Federativa do Brasil. Quaisquer disputas serão resolvidas nos tribunais do Brasil.'
      },
      contact: {
        title: 'Contato',
        description: 'Para dúvidas sobre estes termos e condições, entre em contato através das informações fornecidas acima.'
      },
      lastUpdate: 'Última atualização'
    },
    contact: {
      title: 'Contato',
      company: {
        title: 'Informações da Empresa',
        name: 'Nome da Empresa',
        cnpj: 'CNPJ',
        address: 'Endereço',
        email: 'E-mail',
        phone: 'Telefone'
      },
      social: {
        title: 'Redes Sociais'
      },
      hours: {
        title: 'Horário de Atendimento',
        description: 'Disponível para consultas de segunda a sexta-feira, das 9h às 18h (Horário de Brasília - GMT-3)'
      }
    },
    footer: {
      company: {
        title: 'Empresa',
        name: 'Nome da Empresa',
        cnpj: 'CNPJ',
        address: 'Endereço'
      },
      legal: {
        title: 'Legal',
        privacy: 'Política de Privacidade',
        terms: 'Termos e Condições',
        contact: 'Contato'
      },
      contact: {
        title: 'Contato',
        email: 'E-mail',
        phone: 'Telefone'
      },
      rights: 'Todos os direitos reservados'
    }
  }
}; 